<template>
    <div class="wrap" :class="pageType == 2 && Advertlist.length > 0 ? 'page2' : ''"
        :style="pageType == 2 && Advertlist.length > 0 ? 'background: url(' + Advertlist[0].picturesUrl + ');background-size: 100% 100%;' : ''">
        <div class="banner" v-show="pageType == 1">
            <swiper :options="swiperOption" ref="mySwiper" v-if="Advertlist.length > 0">
                <swiper-slide v-for="(item, index) in Advertlist" :key="index">
                    <img :src="item.picturesUrl" width="100%" @click.stop="jumpurl(item.hyperlinks)" />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <div class="menuWrap" style="margin-bottom: 80px">
            <div class="display_between marginBottom20" v-for="(item, index) in nvgList" :key="index">
                <div class="menuitem" v-for="(itemD, indexD) in item" :key="indexD + 'q'" @click="meetingDetail(itemD)">
                    <div class="topimg">
                        <img :src="itemD.picturesUrl" />
                    </div>
                    <div :class="mtgId == 25 ? 'btitle1' : 'btitle'">
                        {{ itemD.columnName }}
                    </div>
                </div>
                <div class="menuitem" v-for="zhw in 3 - item.length" :key="zhw">
                    <div class="topimg"></div>
                    <div class="btitle"></div>
                </div>
            </div>
        </div>
        <div class="bottom" v-html="bottomText"></div>
        <div class="becomeTJG" v-if="isXSY > 0 && !iswxxcx && isOpenTjg" @click="becomeTJG">成为推荐官</div>
        <div class="bindingTJG" v-if="!isShow && isXSY > 0 && !iswxxcx && isOpenTjg" @click="openBinding">绑定推荐官</div>

        <van-dialog v-model="show" title="绑定推荐官" show-cancel-button confirmButtonText="确定绑定" cancelButtonText="取消绑定"
            @confirm="confirmbBinding">
            <div style="text-align: center; padding: 10px 0">您的学术推荐官: {{ bindingName }}</div>
        </van-dialog>

        <van-dialog v-model="showTwo" title="填写邀请码" show-cancel-button @confirm="confirmbBinding">
            <van-field v-model="value" colon label-width="50" placeholder="请输入邀请码" />
        </van-dialog>
    </div>
</template>

<script>
import lodash from 'lodash';
import axios from 'axios';
import wx from 'weixin-js-sdk';
import { Dialog } from 'vant';
import { Toast } from 'vant';
export default {
    name: 'meetingMobile',
    data() {
        return {
            menu: [],
            nvgList: [],
            mtgId: 2,
            Advertlist: [],
            pageType: 1,
            swiperOption: {
                loop: true, // 循环模式选项
                autoplay: true,
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'bulletWrite',
                    bulletActiveClass: 'bulletWriteActive',
                },
            },
            bottomText: '',
            AuthorId: '',
            qid: 0,
            // isDebug: false
            show: false,
            value: '',
            bindingTitle: '',
            showTwo: false,
            isShow: false,
            isXSY: 0,
            codeTile: '',
            bindingName: '',
            xcxUrl: '',
            iswxxcx: false,
            isOpenTjg: false,
            habitLogin: false,
        };
    },
    created() {
        if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'regclick')) {
            this.regclick(this.$route.query.regclick);
        } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
            this.httphelper
                .post('/api/LoginApi/CheckToken', {
                    tokenKey: this.$route.query.tokenkey,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
                    }
                });
        }

        if (this.$route.query.mid != '') {
            this.mtgId = this.$route.query.mid;
        }
        if (!this.isMobile()) {
            this.$router.push({
                path: '/meetingIndex',
                query: {
                    mid: this.mtgId,
                },
            });
        }
        // console.log(!this.isMobile());

        if (this.isMobile()) {
            if (this.$route.query.mid == 91) {
                Dialog.confirm({
                    title: '会议须知',
                    message: `<div style="text-align: left;"><span style="display: inline-flex; width: 70px; margin-top: 20px">会议地点：</span><span style="display: inline-flex; width: calc(100% - 70px);">中华全国总工会国际交流中心（北京市顺义区后沙峪镇古城村村委会东200米）</span>\n<span style="display: inline-flex; width: 70px; margin-top: 20px">摆渡车安排：</span><span style="display: inline-flex; width: calc(100% - 70px);">乘坐地铁--15号线【花梨坎站】下车，B东北口，换乘大会摆渡车前往会场；去会场发车时间为7:50，8:15各一班；去地铁站发车时间为18:30,19:00各一班</span></div>`,
                    showCancelButton: false,
                });
            } else if (this.$route.query.mid == 134) {
                Dialog.confirm({
                    title: '会议须知',
                    message: `<div style="text-align: left;"><span style="display: inline-flex; width: 70px; margin-top: 20px">会议地点：</span><span style="display: inline-flex; width: calc(100% - 70px);">中华全国总工会国际交流中心（北京市顺义区后沙峪镇古城村村委会东200米）</span>\n<span style="display: inline-flex; width: 70px; margin-top: 20px">摆渡车安排：</span><span style="display: inline-flex; width: calc(100% - 70px);">乘坐地铁--15号线【花梨坎站】-B口（东北口）出，换乘大会摆渡车前往会场；去会场发车时间为7:40；会议结束回地铁站发车时间为18:30,19:00各一班。</span></div>`,
                    showCancelButton: false,
                });
            }
        }

        // this.getData()
        this.getWebSiteConfigList();
        this.getMeetingInfo();

        /** 是否绑定推荐官 */
        if (this.$route.query.code) {
            this.isBindingTJG();
            this.getBindingName();
        }

        // this.getUrl()

        this.wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
                // alert("在小程序里");
                this.iswxxcx = true;
            } else {
                // alert("不在小程序里");
                this.iswxxcx = false;
            }
        });
    },
    methods: {
        getBindingName() {
            let params = {
                MeetId: parseFloat(this.$route.query.mid),
                code: this.$route.query.code,
            };
            this.httphelper.get('/api/MeetInviteApi/GetUserNameBycode', params).then(res => {
                if (res.code == 200) {
                    this.bindingName = res.data;
                } else {
                    Toast.fail('邀请码错误');
                }
            });
        },

        /** 跳转小程序 */
        becomeTJG() {
            window.location.href = this.xcxUrl;
        },

        getData() {
            var that = this;
            fetch('/data.json')
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    var usedata = data.meetingMobile.menu;

                    that.menu = lodash.chunk(usedata, 3);
                });
        },
        getWebSiteConfigList() {
            let _this = this;
            this.httphelper
                .post('/api/WebSiteConfigApi/GetWebSiteConfigList', {
                    mtg_Id: parseInt(_this.mtgId),
                    type: 2,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data.webSiteNaviglist;
                        data.forEach(item => {
                            if (item.parentID == 0) {
                                _this.nvgList.push(item);
                            }
                        });
                        _this.nvgList = lodash.chunk(_this.nvgList, 3);
                        _this.Advertlist = _this.sortKey(res.data.data.advertlist, 'sort'); // res.data.data.advertlist;
                        if (_this.Advertlist.length > 0) this.pageType = _this.Advertlist[0].templateType;
                        if (res.data.data.webSiteConfiglist != null && res.data.data.webSiteConfiglist.length > 0) {
                            this.wxshare(res.data.data.webSiteConfiglist[0]);
                            this.bottomText = res.data.data.webSiteConfiglist[0].websiteBottom;
                        }
                    }
                });
        },
        meetingDetail(item) {
            let _target = '_self';
            //是否在新页面打开
            if (item.isOpenNewpage) {
                _target = '_blank';
            }

            if (item.columnType == '系统类' && item.columnName == '首页') {
                this.$router.push({ name: 'meetingMobile', query: { mid: this.mtgId } });
            } else if (item.columnType == '图文类') {
                const { href } = this.$router.resolve({
                    path: '/meetingMobileDetail',
                    query: { id: item.id, mid: this.mtgId, name: item.columnName },
                });
                window.open(href, _target);
            } else if (item.columnType == '跳转连接') {
                if (item.hyperlinks.indexOf('muduLive') > -1 || item.hyperlinks.indexOf('huodeLive') > -1) {
                    if (this.$cookies.isKey('token_chinagp')) {
                        var _tokenkey = this.$cookies.get('token_chinagp');
                        this.httphelper
                            .post('/api/LoginApi/CheckToken', {
                                tokenKey: _tokenkey,
                            })
                            .then(res => {
                                if (res.data.code == 200) {
                                    this.$cookies.set('token_chinagp', _tokenkey);
                                    this.AuthorId = res.data.data.id;
                                    item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                                    this.toLive(this.getParamQueryString(item.hyperlinks, 'id'), item.hyperlinks.indexOf('muduLive') > 0 ? 1 : 2, item.hyperlinks, _target);
                                    // window.open(item.hyperlinks, _target);
                                } else {
                                    Dialog.alert({
                                        title: '提示',
                                        message: '请先登录',
                                    }).then(() => {
                                        let callback = encodeURIComponent(window.location.href);
                                        // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                        if (this.habitLogin) {
                                            window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                        } else {
                                            window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                        }
                                    });
                                }
                            });
                    } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                        this.httphelper
                            .post('/api/LoginApi/CheckToken', {
                                tokenKey: this.$route.query.tokenkey,
                            })
                            .then(res => {
                                if (res.data.code == 200) {
                                    this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
                                    // item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId + '&tokenkey=' + this.$route.query.tokenkey
                                    // window.open(item.hyperlinks, _target);

                                    this.AuthorId = res.data.data.id;
                                    item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId + '&tokenkey=' + this.$route.query.tokenkey;

                                    this.toLive(this.getParamQueryString(item.hyperlinks, 'id'), item.hyperlinks.indexOf('muduLive') > 0 ? 1 : 2, item.hyperlinks, _target);
                                } else {
                                    Dialog.alert({
                                        title: '提示',
                                        message: '请先登录',
                                    }).then(() => {
                                        let callback = this.delUrlData('tokenkey');
                                        // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + encodeURIComponent(callback);
                                        if (this.habitLogin) {
                                            window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + encodeURIComponent(callback);
                                        } else {
                                            window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + encodeURIComponent(callback);
                                        }
                                    });
                                }
                            });
                    } else {
                        Dialog.alert({
                            title: '提示',
                            message: '请先登录',
                        }).then(() => {
                            let callback = encodeURIComponent(window.location.href);
                            // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                            if (this.habitLogin) {
                                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                            } else {
                                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                            }
                        });
                    }
                } else {
                    if ((item.hyperlinks.indexOf('gp519') > -1 || item.hyperlinks.indexOf('cgphome') > -1) && item.hyperlinks.indexOf('smeagp.gp519.com') < 0 && item.hyperlinks.indexOf('h5rd.gp519.com') < 0) {
                        if (item.hyperlinks.indexOf('mid') > -1) {
                            window.location.href = item.hyperlinks;
                        } else {
                            item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId;
                            window.location.href = item.hyperlinks;
                        }
                    } else {
                        if (this.iswxxcx) {
                            const validExts = /\.(pdf|docx|doc)$/i;
                            if (validExts.test(item.hyperlinks)) {
                                console.log(wx);
                                const url_wx = '/pages/root/webview/web-view?url=' + item.hyperlinks;
                                this.wx.miniProgram.navigateTo({ url: url_wx });
                            } else {
                                window.location.href = item.hyperlinks;
                            }
                        } else {
                            window.location.href = item.hyperlinks;
                        }
                    }
                }
            } else if (item.columnName == '个人注册' || item.columnName == '酒店预订' || item.columnName == '参会注册') {
                //跳转登录页面
                this.regclick(0);
            } else if (item.columnName == '团体注册') {
                //跳转登录页面
                this.regclick(1);
            }
        },
        delUrlData(name) {
            var url = window.location.href;
            var urlparts = url.split('?');
            if (urlparts.length >= 2) {
                //参数名前缀
                var prefix = encodeURIComponent(name) + '=';
                var pars = urlparts[1].split(/[&;]/g);

                //循环查找匹配参数
                for (var i = pars.length; i-- > 0;) {
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        //存在则删除
                        pars.splice(i, 1);
                    }
                }
                return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
            }
            return url;
        },
        regclick(cpg) {
            if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: this.$route.query.tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
                            if (res.data.data.mobile == '' || res.data.data == null) {
                                this.Defconfirm();
                                return;
                            }
                            if (cpg > 0) {
                                // window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg + '&tokenkey=' + this.$route.query.tokenkey;
                                // window.location.href = 'https://h5meeting.gp519.com/admin/home?mid=' + this.mtgId + '&tokenkey=' + this.$route.query.tokenkey;
                                window.location.href = this.httphelper.Ish5DebugH5GP519() + '/admin/home?mid=' + this.mtgId + '&tokenkey=' + this.$route.query.tokenkey;
                            } else {
                                // window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&tokenkey=' + this.$route.query.tokenkey;
                                // window.location.href = 'https://h5meeting.gp519.com/user/home?mid=' + this.mtgId + '&tokenkey=' + this.$route.query.tokenkey;
                                window.location.href = this.httphelper.Ish5DebugH5GP519() + '/user/home?mid=' + this.mtgId + '&tokenkey=' + this.$route.query.tokenkey;
                            }
                        } else {
                            if (cpg > 0) {
                                let callback = encodeURIComponent(window.location.href + '&cgp=' + cpg + '&regclick=1');
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            } else {
                                let callback = encodeURIComponent(window.location.href + '&regclick=0');
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            }
                        }
                    });
            } else if (this.$cookies.isKey('token_chinagp')) {
                var _tokenkey = this.$cookies.get('token_chinagp');
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.mobile == '' || res.data.data == null) {
                                this.Defconfirm();
                                return;
                            }
                            if (cpg > 0) {
                                // window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg + '&tokenkey=' + _tokenkey;
                                // window.location.href = 'https://h5meeting.gp519.com/admin/home?mid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                                window.location.href = this.httphelper.Ish5DebugH5GP519() + '/admin/home?mid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                            } else {
                                // window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                                // window.location.href = 'https://h5meeting.gp519.com/user/home?mid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                                window.location.href = this.httphelper.Ish5DebugH5GP519() + '/user/home?mid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                            }
                        } else {
                            if (cpg > 0) {
                                let callback = encodeURIComponent(window.location.href + '&cgp=' + cpg + '&regclick=1');
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            } else {
                                let callback = encodeURIComponent(window.location.href + '&regclick=0');
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            }
                        }
                    });
            } else {
                if (cpg > 0) {
                    let callback = encodeURIComponent(window.location.href + '&cgp=' + cpg + '&regclick=1');
                    // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    if (this.habitLogin) {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                    } else {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    }
                } else {
                    let callback = encodeURIComponent(window.location.href + '&regclick=0');
                    // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    if (this.habitLogin) {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                    } else {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    }
                }
            }
        },
        Defconfirm() {
            this.$confirm('会议报名必须先完善个人信息, 是否前往用户中心完善个人信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$router.push({ name: 'userInfor' });
            });
        },
        // 判断是手机还是pc
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        },
        getMeetingInfo() {
            let _this = this;
            this.httphelper.get('/api/MeetingApi/GetMeetingInfoByID?mtgId=' + parseInt(this.mtgId)).then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    this.isXSY = res.data.academicMonthId;
                    this.isOpenTjg = res.data.isOpenTjg;
                    _this.habitLogin = res.data.habitLogin;
                    this.getxcxUrl(res.data.academicMonthId);
                    // _this.$route.meta.title = data.mtg_Name;
                    document.title = data.mtg_Name;
                    // _this.$router.replace({
                    //   query: {
                    //     mid: _this.mtgId,
                    //     temp: Date.now()
                    //   }
                    // });
                }
            });
        },
        // 微信分享
        wxshare(item) {
            let urls = '';
            let userAgent = navigator.userAgent;
            if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
                urls = sessionStorage.getItem('originUrl');
            } else {
                urls = window.location.href;
            }
            axios.get('/api/CGpUserApi/GetWXShareConfigInfo?url=' + encodeURIComponent(urls)).then(res => {
                wx.config({
                    debug: false,
                    appId: res.data.data.appid,
                    timestamp: res.data.data.timestamp,
                    nonceStr: res.data.data.nonceStr,
                    signature: res.data.data.signature,
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
                });

                wx.ready(function () {
                    wx.updateAppMessageShareData({
                        title: item.mWebsiteTitle,
                        desc: item.mWebsiteDesc == null ? '' : item.mWebsiteDesc,
                        link: window.location.href,
                        imgUrl: item.picturesUrl,
                        type: 'link',
                        dataUrl: '',
                        success: function () { },
                    });
                    wx.updateTimelineShareData({
                        title: item.mWebsiteTitle,
                        desc: item.mWebsiteDesc == null ? '' : item.mWebsiteDesc,
                        link: window.location.href,
                        imgUrl: item.picturesUrl,
                        type: 'link',
                        dataUrl: '',
                        success: function () { },
                    });
                });
            });
        },
        getParamQueryString(url, name) {
            let subStr = name + '=';
            if (url.indexOf(subStr) !== -1) {
                let arr = url.split(subStr);
                let sub1 = arr[1];
                if (sub1.indexOf('&') !== -1) {
                    let arr2 = sub1.split('&');
                    let sub2 = arr2[0];
                    return sub2;
                } else {
                    return sub1;
                }
            }
            return '';
        },
        toLive(id, liveType, url, target) {
            //验证是否需要报名
            this.httphelper
                .post('/api/LiveApi/GetLiveRegistSet', {
                    LiveId: id.toString(),
                    LiveType: parseInt(liveType),
                    MtgId: parseInt(this.mtgId),
                    UserId: parseInt(this.AuthorId),
                })
                .then(res => {
                    if (res.data.code != 200) {
                        //请先报名
                        Dialog.alert({
                            title: '提示',
                            message: '请先报名会议在观看',
                        }).then(() => {
                            this.regcheck();
                        });
                    } else {
                        //已经报名了，跳转直播页面
                        // window.open(url, target);
                        if (this.mtgId > 0) {
                            this.CheckIsQuestionnaire(url, target);
                        } else {
                            //已经报名了，跳转直播页面
                            window.open(url, target);
                        }
                    }
                });
        },
        //验证是否需要问卷
        CheckIsQuestionnaire(url, target) {
            this.httphelper.get('/api/LiveApi/CheckIsQuestionnaire?mid=' + this.mtgId).then(res => {
                if (res.code == 200) {
                    window.open(url, target);
                } else {
                    if (res.code == 20) {
                        this.qid = res.data.id;
                        //验证当前用户是否报名
                        this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedbackList?qid=' + res.data.id + '&userid=' + this.AuthorId + '&expiretype=' + res.data.expireType).then(res => {
                            if (res.code == 200) {
                                //继续观看
                                window.open(url, target);
                            } else {
                                //跳转调查问卷
                                Dialog.alert({
                                    title: '提示',
                                    message: '请先填写调查问卷',
                                }).then(() => {
                                    let callback = encodeURIComponent(window.location.href);
                                    this.$router.push({
                                        path: '/question?',
                                        query: {
                                            qid: this.qid,
                                            callback: callback,
                                        },
                                    });
                                });
                            }
                        });
                    } else {
                        Toast.fail(res.msg);
                    }
                }
            });
        },
        //判断是否报名，否跳转会议报名
        regcheck() {
            if (this.$cookies.isKey('token_chinagp')) {
                var _tokenkey = this.$cookies.get('token_chinagp');
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.mobile == '' || res.data.data == null) {
                                this.Defconfirm();
                                return;
                            }
                            window.location.href = 'https://h5meeting.gp519.com/user/home?mid=' + this.mtgId;
                        } else {
                            let callback = encodeURIComponent('https://h5meeting.gp519.com/user/home?mid=' + this.mtgId);
                            if (this.habitLogin) {
                                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                            } else {
                                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                            }
                        }
                    });
            } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: this.$route.query.tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            if (res.data.data.mobile == '' || res.data.data == null) {
                                this.Defconfirm();
                                return;
                            }
                            // window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                            window.location.href = 'https://h5meeting.gp519.com/user/home?mid=' + this.mtgId;
                        } else {
                            // let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                            let callback = encodeURIComponent('https://h5meeting.gp519.com/user/home?mid=' + this.mtgId);
                            // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                            if (this.habitLogin) {
                                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                            } else {
                                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                            }
                        }
                    });
            } else {
                var hrefurl = '';
                // hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                hrefurl = 'https://h5meeting.gp519.com/user/home?mid=' + this.mtgId;
                let callback = encodeURIComponent(hrefurl);
                if (this.habitLogin) {
                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                } else {
                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                }
            }
        },
        jumpurl(url) {
            if (url != null && url != '') window.open(url, '_blank');
        },
        sortKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return x < y ? -1 : x > y ? 1 : 0;
            });
        },

        /** 判断是否绑定推荐官 */
        isBindingTJG() {
            if (this.$route.query.code) {
                if (this.$cookies.isKey('token_chinagp')) {
                    var _tokenkey = this.$cookies.get('token_chinagp');
                    this.httphelper
                        .post('/api/LoginApi/CheckToken', {
                            tokenKey: _tokenkey,
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.AuthorId = res.data.data.id;
                                let params = {
                                    UserId: res.data.data.id,
                                    MeetId: parseInt(this.mtgId),
                                    code: this.$route.query.code,
                                };
                                this.httphelper.get('/api/MeetInviteApi/GetUserBindInvite', params).then(res => {
                                    console.log(res, '===');
                                    if (res.code == 200) {
                                        this.isShow = res.data.isbinding;
                                        if (res.data.isinvite) {
                                            this.show = true;
                                            this.value = this.$route.query.code;
                                        }
                                    }
                                });
                            } else {
                                this.show = true;
                                this.value = this.$route.query.code;
                            }
                        });
                } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                    this.httphelper
                        .post('/api/LoginApi/CheckToken', {
                            tokenKey: this.$route.query.tokenkey,
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.AuthorId = res.data.data.id;
                                let params = {
                                    UserId: res.data.data.id,
                                    MeetId: parseInt(this.mtgId),
                                    code: this.$route.query.code,
                                };
                                this.httphelper.get('/api/MeetInviteApi/GetUserBindInvite', params).then(res => {
                                    if (res.code == 200) {
                                        this.isShow = res.data.isbinding;
                                        if (res.data.isinvite) {
                                            this.show = true;
                                            this.value = this.$route.query.code;
                                        }
                                    }
                                });
                            } else {
                                this.show = true;
                                this.value = this.$route.query.code;
                            }
                        });
                } else {
                    this.show = true;
                    this.value = this.$route.query.code;
                }
            } else {
                if (this.$cookies.isKey('token_chinagp')) {
                    var _tokenkey = this.$cookies.get('token_chinagp');
                    this.httphelper
                        .post('/api/LoginApi/CheckToken', {
                            tokenKey: _tokenkey,
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.AuthorId = res.data.data.id;
                                let params = {
                                    UserId: res.data.data.id,
                                    MeetId: parseInt(this.mtgId),
                                    code: this.$route.query.code,
                                };
                                this.httphelper.get('/api/MeetInviteApi/GetUserBindInvite', params).then(res => {
                                    console.log(res, '===');
                                    if (res.code == 200) {
                                        this.isShow = res.data.isbinding;
                                    }
                                });
                            } else {
                                let callback = encodeURIComponent(window.location.href);
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                            }
                        });
                } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                    this.httphelper
                        .post('/api/LoginApi/CheckToken', {
                            tokenKey: this.$route.query.tokenkey,
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.AuthorId = res.data.data.id;
                                let params = {
                                    UserId: res.data.data.id,
                                    MeetId: parseInt(this.mtgId),
                                    code: this.$route.query.code,
                                };
                                this.httphelper.get('/api/MeetInviteApi/GetUserBindInvite', params).then(res => {
                                    if (res.code == 200) {
                                        this.isShow = res.data.isbinding;
                                    }
                                });
                            } else {
                                let callback = encodeURIComponent(window.location.href);
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            }
                        });
                }
            }
        },

        /** 绑定推荐官 */
        confirmbBinding() {
            if (this.$cookies.isKey('token_chinagp')) {
                var _tokenkey = this.$cookies.get('token_chinagp');
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            let params = {
                                UserId: res.data.data.id,
                                MeetId: parseInt(this.mtgId),
                                InviteCode: this.value,
                            };
                            this.httphelper.post('/api/MeetInviteApi/UserInvitebind', params).then(res => {
                                if (res.data.code == 200) {
                                    this.isShow = true;
                                    Toast.success('绑定成功');
                                } else {
                                    Toast.fail(res.data.msg);
                                }
                            });
                        } else {
                            Dialog.alert({
                                title: '提示',
                                message: '请先登录',
                            }).then(() => {
                                let callback = encodeURIComponent(window.location.href);
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            });
                        }
                    });
            } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: this.$route.query.tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            let params = {
                                UserId: res.data.data.id,
                                MeetId: parseInt(this.mtgId),
                                InviteCode: this.value,
                            };
                            this.httphelper.post('/api/MeetInviteApi/UserInvitebind', params).then(res => {
                                if (res.data.code == 200) {
                                    this.isShow = true;
                                    Toast.success('绑定成功');
                                } else {
                                    Toast.fail(res.data.msg);
                                }
                            });
                        } else {
                            Dialog.alert({
                                title: '提示',
                                message: '请先登录',
                            }).then(() => {
                                let callback = encodeURIComponent(window.location.href);
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            });
                        }
                    });
            } else {
                Dialog.alert({
                    title: '提示',
                    message: '请先登录',
                }).then(() => {
                    let callback = encodeURIComponent(window.location.href);
                    // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    if (this.habitLogin) {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                    } else {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    }
                });
            }
        },

        /** 打开绑定弹窗 */
        openBinding() {
            if (this.$cookies.isKey('token_chinagp')) {
                var _tokenkey = this.$cookies.get('token_chinagp');
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$cookies.set('token_chinagp', _tokenkey);
                            this.AuthorId = res.data.data.id;
                            this.showTwo = true;
                        } else {
                            Dialog.alert({
                                title: '提示',
                                message: '请先登录',
                            }).then(() => {
                                let callback = encodeURIComponent(window.location.href);
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            });
                        }
                    });
            } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: this.$route.query.tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
                            this.AuthorId = res.data.data.id;
                            this.showTwo = true;
                        } else {
                            Dialog.alert({
                                title: '提示',
                                message: '请先登录',
                            }).then(() => {
                                let callback = encodeURIComponent(window.location.href);
                                // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                if (this.habitLogin) {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                                } else {
                                    window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                                }
                            });
                        }
                    });
            } else {
                Dialog.alert({
                    title: '提示',
                    message: '请先登录',
                }).then(() => {
                    let callback = encodeURIComponent(window.location.href);
                    // window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    if (this.habitLogin) {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/userlogin?callback=' + callback;
                    } else {
                        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                    }
                });
            }
        },

        /** 获取小程序链接 */
        getxcxUrl(id) {
            let params = {
                acid: id,
            };
            this.httphelper.get('/api/AcademicMonthApi/GetschemeUrl', params).then(res => {
                if (res.code == 200 && res.data.errmsg == 'ok') {
                    this.xcxUrl = res.data.openlink;
                }
            });
        },
    },
    beforeRouteEnter(to, from, next) {
        let userAgent = navigator.userAgent;

        if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
            sessionStorage.setItem('originUrl', location.href); // 用于ios分享
        }

        next();
    },
};
</script>

<style scoped lang="scss">
.menuitem {
    width: 30%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.topimg {
    width: 75px;
    height: 75px;
}

.topimg img {
    width: 100%;
}

.menuWrap {
    padding: 10px 30px;
    margin-top: 40px;
}

.btitle {
    margin-top: 5px;
}

.btitle1 {
    margin-top: 5px;
    color: white;
}

.wrap {
    flex: 1;
}

.bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    padding-bottom: 20px;
}

.page2 {
    padding-top: 240px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.van-dialog ::v-deep .van-dialog__content ::v-deep .van-dialog__message {
    background: red($color: #000000);
}

.becomeTJG,
.bindingTJG {
    position: fixed;
    right: 0;
    top: 290px;
    width: 12px;
    padding: 10px;
    font-size: 12px;
    // line-height: 14px;
    color: #fff;
    background-color: #4280f8;
    background: linear-gradient(to bottom right, #4280f8, #6241fe);
    border-radius: 6px 0 0 6px;
    z-index: 1999;
}

.bindingTJG {
    top: 400px;
}

::v-deep .van-cell {
    padding: 15px 30px;
}
</style>
